// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Public reCAPTCHA v3 site key for Firebase App Check (safe to commit, like the
// web config above). Paste the key from Firebase Console -> App Check. Empty
// string disables App Check (e.g. before setup), so the app still builds and runs.
const RECAPTCHA_SITE_KEY = "6LdYNDUtAAAAAE4gxrBJkO4hsfV7eadQFbil0DQM";

const firebaseConfig = {
  apiKey: "AIzaSyD9uSi3SNWAX4BZLrDu_SuzD1kK-EUPmLk",
  authDomain: "lafrun-web.firebaseapp.com",
  projectId: "lafrun-web",
  storageBucket: "lafrun-web.firebasestorage.app",
  messagingSenderId: "26061716573",
  appId: "1:26061716573:web:9a28d03e37a818f63861b4",
  measurementId: "G-4KEM252L8C",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
// Google is the only configured sign-in provider (enabled in the Firebase console).
const googleProvider = new GoogleAuthProvider();

// App Check proves requests come from the genuine Lafrun app, blocking scripts
// that hit the backend directly. Initialised in production only so local dev
// (npm start) is not blocked; null elsewhere. The gemini function and Firestore
// verify the token this mints.
let appCheck = null;
if (process.env.NODE_ENV === "production" && RECAPTCHA_SITE_KEY) {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
    isTokenAutoRefresh: true,
  });
}

export { app, db, auth, googleProvider, appCheck };
